<template lang="pug">
  vm-prompt(@vm-cancel="close" vm-size="medium" @vm-accept="close" @vm-close="close" :vm-active="isModalShipmentDetailVisible" :vm-title='title' :vm-detail='detail'  :vm-show-buttons="false")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        h3 {{ detail }}
        vm-table(max-height="350px" :data="allDetails")
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ column }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column === 'mark'") {{tr['mark']}}
                slot(v-if="column === 'scope'") {{tr['scope']}}
                slot(v-if="column === 'send/missing'") {{tr['shipment_complete_total']}}
                slot(v-if="column === 'sequence'") {{tr['sequence']}}
                slot(v-if="column === 'fabricated/quoted'") {{tr['fabricated']}}
                slot(v-if="column === 'quantity'")
                  vm-input(
                    :placeholder="edit"
                    :danger="edit"
                    :danger-text="edit" v-model="tr['quantity']"
                    :label='edit' type="number"  required
                    style="width: 80px; padding: 0; margin: 0;")
                    vm-col(vm-justify="center", vm-align="center", vm-w=1)
                slot(v-if="column === 'missing'") {{tr['missing']}}
                slot(v-if="column === '-'")
                  vm-button(v-if="tr.quantity !== '' && parseInt(tr.quantity, 10) !== 0 && tr.missing >= parseInt(tr.quantity, 10)" icon="save-outline" color="red" @click="updateShipmentOneDetail(tr)") add
                  vm-button(v-if="tr.quantity === '' || parseInt(tr.quantity, 10) === 0" icon="save-outline" color="white" @click="") add
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalShipmentDetailVisible',
  shipments_remaining: [],
  data: () => ({ columns: ['scope', 'send/missing', 'fabricated/quoted', 'quantity', 'missing', '-'] }),
  props: {
    title: {
      type: String,
      default: 'ModalShipmentDetail'
    }
  },
  computed: {
    ...mapGetters([
      'isModalShipmentDetailVisible',
      'imageIdProject',
      'imageIdCategory',
      'categories',
      'inOrder',
      'shipment',
      'allDetails'

    ])
  },

  methods: {
    ...mapActions([
      'importScopeData',
      'updateShipmentDetails',
      'addShipmentDetail',
      'loadInOrderDetailsWithShipment',
      'setModalShipmentDetailVisible'
    ]),

    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    importAction () {
      this.importScopeData({ file: this.file, project_id: this.project_id })
    },
    close () {
      this.setModalShipmentDetailVisible(false)
    },
    async updateShipmentOneDetail (tr) {
      tr.val = parseInt(tr.quantity, 10)
      if (tr['val'] <= tr['missing']) {
        tr.project_detail_id = tr.id
        tr.shipment_id = this.$route.params.idshipment
        tr.scope_id = tr.id
        tr.updated_at = this.date
        let [total, required] = tr.fabricated.split('/')
        let [send, miss] = tr.shipment_complete_total.split('/')
        send = parseInt(send, 10) + parseInt(tr.val, 10)
        miss = parseInt(miss, 10) - parseInt(tr.val, 10)
        tr.missing = miss
        tr.fabricated = `${total}/${required}`
        tr.shipment_complete_total = `${send}/${miss}`

        await this.addShipmentDetail({
          id: this.$route.params.id,
          shipment_id: this.$route.params.idshipment,
          details: [tr],
          fabricated_date: this.date
        })
        this.$route.params.idshipment && await this.loadInOrderDetailsWithShipment({ id: this.$route.params.id, idshipment: this.$route.params.idshipment })
      }
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
.image {
    width: 100%;
    height: 100%;
    background: #e4e4e4;
    box-sizing: content-box;
}
a {
  cursor: pointer;
}
</style>
